module.exports = __webpack_public_path__ + "static/img/yizhishi.7c35300d.png";